



























































































































import {Component, Prop} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {PickingListTranshipmentStore} from "@/modules/pickinglisttranshipment";
import {Lading} from "@/interfaces/entity";
import {LadingStatus, PickingListTranshipmentStatus} from "@/enums/status";
import LadingStatusLabel from "@/shared/components/LadingStatusLabel/index.vue";
import {deleteBillLadingOfPickingList} from "@/modules/pickinglistdeliveries/services";
import {PickingListDeliveryStore} from "@/modules/pickinglistdeliveries";
import {deleteBillLadingOfPickingListTranshipment} from "@/modules/pickinglisttranshipment/services";

@Component({
  name: "PLTranshipmentPrint",
  components: {LadingStatusLabel},
})
export default class extends mixins(CommonMixin) {
  @Prop({required: true, type: Number}) readonly id!: number;
  @Prop({ type: Boolean, default: false }) readonly isPrint!: boolean;
  @Prop({ type: Boolean, default: false }) readonly isConfirmedTo!: boolean;
  LadingStatus = LadingStatus;
  PickingListTranshipmentStatus = PickingListTranshipmentStatus;

  get billLadings() {
    const billLadings = this.getProp(this.pickingListTranshipment, 'billLadings', []) as any;
    return billLadings.map((billLading: Lading, index) => ({...billLading, stt: index + 1}));
  }

  get pickingListTranshipment() {
    return PickingListTranshipmentStore.data[this.id];
  }

  async deleteBillLading(billLadingRowGuid: string) {
    try {
      if (this.billLadings.length < 2) {
        this.$message.error('Bảng kê chỉ có 1 vận đơn, vui lòng hủy bảng kê');
        return;
      }
      await deleteBillLadingOfPickingListTranshipment({ billLadingRowGuid, pickingListTranshipmentId: this.id });
      const billLadings = PickingListTranshipmentStore.data[this.id]?.billLadings;
      billLadings.splice(billLadings.findIndex((billLading: Lading) => billLading.rowGuid === billLadingRowGuid), 1);
      this.$message.success("Xóa vận đơn thành công");
    } catch (e) {
      this.$message.error(e?.response?.data?.message || 'Xóa vận đơn thất bại');
    }
  }
}
